module.exports = __webpack_public_path__ + "img/movie_field_position_setting.f6f857b2.gif";